import Amplify from 'aws-amplify';
import amplifyConfig from './aws-exports.json';
import { Auth } from 'aws-amplify';
import { CognitoUser } from '@aws-amplify/auth';
import { ISignUpResult } from 'amazon-cognito-identity-js';
import { authFailed, setUserEmail } from '../redux/actions';
import { store } from '../redux/store';

Amplify.configure(amplifyConfig);

export default class Authenticate {
    static USER_NOT_FOUND_EXCEPTION = 'UserNotFoundException';
    static NOT_AUTHORIZED_EXCEPTION = 'NotAuthorizedException';
    static USERNAME_EXISTS_EXCEPTION = 'UsernameExistsException';
    static CODE_MISMATCH_EXCEPTION = 'CodeMismatchException';

    static async authenticate(
        username: string,
        password: string
    ): Promise<boolean> {
        console.log('authenticate called for u: ', username);
        let user: CognitoUser;

        try {
            user = await Auth.signIn(username, password);
        } catch (e: AuthError | any) {
            console.log('Auth.signIn failed: ', e);
            store.dispatch(authFailed(e));
        }

        if (user) {
            const currentCredentials = await Auth.currentCredentials();
            await Auth.updateUserAttributes(user, {
                'custom:cognitoIdentityId': currentCredentials.identityId,
            });
            store.dispatch(setUserEmail(username));
            return true;
        } else {
            return false;
        }
    }

    static async signup(username: string, password: string): Promise<boolean> {
        console.log('signup called for u: ', username);
        let signUpResult: ISignUpResult;

        try {
            signUpResult = await Auth.signUp(username, password, username);
        } catch (e: AuthError | any) {
            console.log('Auth.signup failed: ', e);
            store.dispatch(authFailed(e));
            return undefined;
        }

        if (signUpResult) {
            store.dispatch(setUserEmail(username));
            return true;
        } else {
            return false;
        }
    }

    static async passwordResetRequest(username: string): Promise<boolean> {
        console.log('passwordReset called for u: ', username);

        let user: CognitoUser;

        try {
            user = await Auth.forgotPassword(username);
        } catch (e: AuthError | any) {
            console.log('Auth.forgotPassword failed: ', e);
            store.dispatch(authFailed(e));
        }

        if (user) {
            store.dispatch(setUserEmail(username));
            return true;
        } else {
            return false;
        }
    }

    static async passwordResetValidate(
        password: string,
        validationCode: string
    ): Promise<boolean> {
        const { userEmail: passwordResetEmail } = store.getState();
        console.log('passwordResetValidate called for u: ', passwordResetEmail);

        try {
            await Auth.forgotPasswordSubmit(
                passwordResetEmail,
                validationCode,
                password
            );
        } catch (e: AuthError | any) {
            console.log('Auth.forgotPasswordSubmit failed: ', e);
            store.dispatch(authFailed(e));
            return false;
        }

        return true;
    }

    static getAuthenticationError(): AuthError {
        const { authError } = store.getState();
        return authError;
    }

    static async signOut(): Promise<boolean> {
        try {
            await Auth.signOut();
            return true;
        } catch (e: AuthError | any) {
            console.log('Auth.signOut failed: ', e);
            store.dispatch(authFailed(e));
            return false;
        }
    }

    static async getCurrentUserEmail(): Promise<string> {
        try {
            const user = await Auth.currentAuthenticatedUser({
                bypassCache: false,
            });

            return user?.attributes?.email;
        } catch (error) {
            console.error(error);
            return '';
        }
    }
}
